import CategorySliderComponent, { Category } from "./categorySlider.component";

export type CategoriesContainerProps = {
    categories: Array<Category>;
};

const CategoriesContainer = ({ categories }: CategoriesContainerProps) => {
    return <CategorySliderComponent categories={categories} />;
};

export { CategoriesContainer };
